import { NgModule } from "@angular/core";
import { CarrierLogic } from "../providers/component-logic/carrier.logic";
import { ChangeSpvLogic } from "../providers/component-logic/change-spv.logic";
import { CompanyProfileLogic } from "../providers/component-logic/company-profile.logic";
import { EditcompanyProfileLogic } from "../providers/component-logic/editcompany-profile.logic";
import { EmpRehireLogic } from "../providers/component-logic/emp-rehire.logic";
import { SharedLogic } from "../providers/component-logic/shared.logic";
import { AuthenticationBloc } from "./authentication/authentication.bloc";
import { InitializeBloc } from "./authentication/initialize.bloc";
import { MultipleAccountBloc } from "./authentication/multiple-account.bloc";
import { SyncBloc } from "./authentication/sync.bloc";
import { CompanySetUpBloc } from "./company/company-setup.bloc";
import { CompanyBloc } from "./company/company.bloc";
import { OrganizationStructureBloc } from "./company/organization-structure.bloc";
import { TeammatesBloc } from "./company/teammates.bloc";
import { ActivityRecordingBloc } from "./feature/activity-recording/activity-recording.bloc";
import { BackgroundGeolocationBloc } from "./feature/background-geolocation/background-geolocation.bloc";
import { BenefitBloc } from "./feature/benefit/benefit.bloc";
import { CareerBloc } from "./feature/career/career.bloc";
import { CompanyMoodBloc } from "./feature/company-mood/company-mood.bloc";
import { FaceThermalBloc } from "./feature/face-thermal/face-thermal.bloc";
import { ForgotPasswordRecruitmentBloc } from "./feature/forgot-password/forgot-password-recruitment.bloc";
import { ForgotPasswordBloc } from './feature/forgot-password/forgot-password.bloc';
import { HomeBloc } from './feature/home/home.bloc';
import { IdCardBloc } from "./feature/id-card/id-card.bloc";
import { OnBoardingBloc } from './feature/on-boarding/on-boarding.bloc';
import { PanicBloc } from "./feature/panic/panic.bloc";
import { PollingBloc } from "./feature/polling/polling.bloc";
import { LookupBloc } from "./feature/profile/lookup.bloc";
import { ProfileBankAccountBloc } from './feature/profile/profile-bank-account/profile-bank-account.bloc';
import { ProfileBankDistributionBloc } from "./feature/profile/profile-bank-distribution/profile-bank-distribution.bloc";
import { ProfileCertificationtBloc } from "./feature/profile/profile-certification/profile-certification.bloc";
import { ProfileChecklistBloc } from "./feature/profile/profile-checklist.bloc";
import { ProfileCompanyfacilityBloc } from "./feature/profile/profile-companyfacility/profile-companyfacility.bloc";
import { ProfileCompanygroupBloc } from "./feature/profile/profile-companygroup.bloc";
import { ProfileCourseBloc } from "./feature/profile/profile-course/profile-course.bloc";
import { ProfileDocumentcontrolBloc } from "./feature/profile/profile-documentcontrol.bloc";
import { ProfileLangSkillBloc } from "./feature/profile/profile-langskill/profile-langskill.bloc";
import { ProfileMedicalHistoryBloc } from "./feature/profile/profile-medical/profile-medicalhistory.bloc";
import { ProfileOrgactivBloc } from "./feature/profile/profile-orgactiv.bloc";
import { ProfilePsychologicalTestBloc } from "./feature/profile/profile-psychological-test.bloc";
import { ProfileReferenceBloc } from "./feature/profile/profile-reference.bloc";
import { ProfileServiceagreementBloc } from "./feature/profile/profile-serviceagreement.bloc";
import { ProfileSf6Bloc } from "./feature/profile/profile-sf6.bloc";
import { ProfileBloc } from "./feature/profile/profile.bloc";
import { ReportProblemsBloc } from "./feature/report-problems/report-problems.bloc";
import { RequestInboxBloc } from "./feature/request/request-inbox.bloc";
import { TaskAndFeedbackBloc } from "./feature/task-and-feedback/task-and-feedback.bloc";
import { TrackerBloc } from "./feature/tracker/tracker.bloc";
import { UserFeedbackBloc } from "./feature/user-feedback/user-feedback.bloc";
import { AttendanceCorrectionBloc } from "./hr/attendance-correction/attendance-correction.bloc";
import { AttendanceFaceBloc } from "./hr/attendance/attendance-face.bloc";
import { AttendanceMachineBloc } from "./hr/attendance/attendance-machine.bloc";
import { AttendanceTempBloc } from "./hr/attendance/attendance-temp.bloc";
import { AttendanceBloc } from "./hr/attendance/attendance.bloc";
import { ClaimBloc } from "./hr/claim/claim.bloc";
import { LetterBloc } from "./hr/employee/letter.bloc";
import { InviteMemberBloc } from "./hr/invite-member/invite-member.bloc";
import { LeaveBloc } from "./hr/leave/leave.bloc";
import { CompanyDataSetupMyBloc } from './hr/payroll/company-data-setup-my.bloc';
import { PayslipBloc } from "./hr/payroll/payslip.bloc";
import { PerformanceEvaluationBloc } from "./hr/performance-sf6/performance-evaluation.bloc";
import { PerformanceMonitoringBloc } from "./hr/performance-sf6/performance-monitoring.bloc";
import { PerformancePlanningBloc } from "./hr/performance-sf6/performance-planning.bloc";
import { Question360Bloc } from "./hr/performance-sf6/question360.bloc";
import { ApplicantBloc } from "./hr/recruitment/applicant.bloc";
import { ShiftDailySettingBloc } from "./hr/shift/shift-daily-setting.bloc";
import { ShiftscheduleBloc } from "./hr/shift/shiftschedule.bloc";
import { TrainingNewrequestBloc } from "./hr/training/training-newrequest.bloc";
import { AbswReportBloc } from "./report/absw-report.bloc";
import { AttendanceLocationReportBloc } from "./report/attendance-location-report.bloc";
import { AttendanceReportBloc } from "./report/attendance-report.bloc";
import { AttendanceSummaryBloc } from "./report/attendance-summary.bloc";
import { BusinessTripReportBloc } from './report/business-trip-report.bloc';
import { CareerReportBloc } from './report/career-report.bloc';
import { ClaimReportBloc } from './report/claim-report.bloc';
import { EmpOvertimeReportBloc } from "./report/emp-overtime-report.bloc";
import { EmployeeListReportBloc } from "./report/employee-list-report.bloc";
import { EmployeeLoanReportBloc } from "./report/employee-loan-report.bloc";
import { EmployeeRequestReportBloc } from "./report/employee-request-report.bloc";
import { GdEventReportBloc } from "./report/gd-event-report.bloc";
import { HeadCountReportBloc } from "./report/head-count-report.bloc";
import { LoanRequestReportBloc } from "./report/loan-request-report.bloc";
import { OvertimeReportBloc } from "./report/overtime-report.bloc";
import { PerformanceReportBloc } from "./report/performance-report.bloc";
import { PersonalReportBloc } from "./report/personal-report.bloc";
import { PollingReportBloc } from "./report/polling-report.bloc";
import { ShiftReportBloc } from "./report/shift-report.bloc";
import { TimesheetReportBloc } from "./report/timesheet-report.bloc";
import { AuthenticatorBloc } from './settings/authenticator.bloc';
import { ChangeAccessBloc } from "./settings/change-access.bloc";
import { ChangeApproverBloc } from "./settings/change-approver.bloc";
import { ChangeHRBloc } from "./settings/change-hr.bloc";
import { ChangePasswordBloc } from './settings/change-password.bloc';
import { ChangePrivacyBloc } from "./settings/change-privacy.bloc";
import { NationalityBloc } from "./settings/employee-setup/nationality.bloc";
import { ReligionBloc } from "./settings/employee-setup/religion.bloc";
import { SettingOnboardingBloc } from "./settings/employee-setup/setting-onboarding.bloc";
import { SettingTimezonenBloc } from "./settings/employee-setup/setting-timezone.bloc";
import { GroupMemberBloc } from "./settings/function-authorization/group-member.bloc";
import { GoogleAccountBloc } from "./settings/google-account.bloc";
import { HolidaySettingBloc } from './settings/holiday-setting.bloc';
import { SetDeviceBloc } from "./settings/set-device.bloc";
import { StandardizedDataBloc } from "./settings/standardized-data.bloc";
import { WorkflowSettingBloc } from "./settings/workflow-setting.bloc";
import { AcrReportBloc } from "./report/acr-report.bloc";
import { CalendarBloc } from "./feature/calendar/calendar.bloc";
import { OvertimeCancelReportBloc } from "./report/overtime-cancel-report.bloc";
import { PolicyBloc } from "./company/policy.bloc";
@NgModule({
  declarations: [],
  imports: [],
  providers: [
    ChangeAccessBloc,
    ChangePrivacyBloc,
    EmpRehireLogic,
    ChangeSpvLogic,
    SharedLogic,
    CompanyProfileLogic,
    CarrierLogic,
    EditcompanyProfileLogic,
    SetDeviceBloc,
    ChangePasswordBloc,
    AuthenticationBloc,
    PollingReportBloc,
    PayslipBloc,
    PollingReportBloc,
    HeadCountReportBloc,
    HomeBloc,
    OvertimeReportBloc,
    UserFeedbackBloc,
    ForgotPasswordBloc,
    ForgotPasswordRecruitmentBloc,
    ProfileBankAccountBloc,
    EmpOvertimeReportBloc,
    InviteMemberBloc,
    InitializeBloc,
    AuthenticatorBloc,
    BackgroundGeolocationBloc,
    AttendanceBloc,
    ShiftDailySettingBloc,
    OrganizationStructureBloc,
    HolidaySettingBloc,
    EmployeeRequestReportBloc,
    TaskAndFeedbackBloc,
    ClaimReportBloc,
    ChangeApproverBloc,
    CareerBloc,
    ProfileBloc,
    AttendanceReportBloc,
    AttendanceSummaryBloc,
    HolidaySettingBloc,
    AbswReportBloc,
    AttendanceCorrectionBloc,
    StandardizedDataBloc,
    ClaimBloc,
    BusinessTripReportBloc,
    ShiftscheduleBloc,
    CareerReportBloc,
    PollingBloc,
    CompanyBloc,
    PanicBloc,
    AttendanceTempBloc,
    FaceThermalBloc,
    GroupMemberBloc,
    LeaveBloc,
    TrainingNewrequestBloc,
    CompanyDataSetupMyBloc,
    LeaveBloc,
    RequestInboxBloc,
    WorkflowSettingBloc,
    IdCardBloc,
    ProfileBankDistributionBloc,
    PerformanceReportBloc,
    AttendanceMachineBloc,
    ProfileCertificationtBloc,
    OnBoardingBloc,
    ProfileCompanyfacilityBloc,
    BenefitBloc,
    TimesheetReportBloc,
    GdEventReportBloc,
    EmployeeListReportBloc,
    MultipleAccountBloc,
    CompanyMoodBloc,
    LetterBloc,
    ProfileSf6Bloc,
    ProfileCourseBloc,
    ProfileLangSkillBloc,
    ProfileMedicalHistoryBloc,
    ReportProblemsBloc,
    ReportProblemsBloc,
    ProfileDocumentcontrolBloc,
    ProfileReferenceBloc,
    ProfileCompanygroupBloc,
    ProfileChecklistBloc,
    ProfileServiceagreementBloc,
    ProfilePsychologicalTestBloc,
    AttendanceFaceBloc,
    CompanySetUpBloc,
    LoanRequestReportBloc,
    EmployeeLoanReportBloc,
    ProfileOrgactivBloc,
    ReligionBloc,
    NationalityBloc,
    TrackerBloc,
    LookupBloc,
    ActivityRecordingBloc,
    SettingTimezonenBloc,
    PerformancePlanningBloc,
    Question360Bloc,
    TeammatesBloc,
    ChangeHRBloc,
    PerformanceEvaluationBloc,
    ShiftReportBloc,
    SettingOnboardingBloc,
    PersonalReportBloc,
    PerformanceMonitoringBloc,
    AttendanceLocationReportBloc,
    ApplicantBloc,
    SyncBloc,
    GoogleAccountBloc,
    AcrReportBloc,
    CalendarBloc,
    OvertimeCancelReportBloc,
    PolicyBloc
  ]
})
export class BlocModule { }



// WEBPACK FOOTER //
// ./src/bloc/bloc.module.ts